import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useLang } from "@/context/LangContext";

const EASE_IO = [0.76, 0, 0.24, 1];

export const Intro = ({ onDone }) => {
  const [lit, setLit] = useState(0);
  const [out, setOut] = useState(false);
  const { t } = useLang();

  useEffect(() => {
    const timers = [1, 2, 3, 4, 5].map((i) => setTimeout(() => setLit(i), i * 200));
    timers.push(setTimeout(() => { setLit(0); setOut(true); }, 1450));
    timers.push(setTimeout(() => onDone(), 1600));
    return () => timers.forEach(clearTimeout);
  }, [onDone]);

  return (
    <motion.div
      data-testid="intro-overlay"
      className={`fixed inset-0 z-[100] flex flex-col items-center justify-center bg-ink ${out ? "pointer-events-none" : ""}`}
      animate={out ? { y: "-100%" } : { y: "0%" }}
      transition={{ duration: 0.9, ease: EASE_IO, delay: 0.15 }}
    >
      <img src="/brand/lp-mark.png" alt="" className="mb-10 h-14 w-auto sm:h-16" />
      <div className="flex gap-3 sm:gap-5">
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="flex flex-col gap-2 rounded-md bg-surface p-2 sm:p-3">
            {[0, 1].map((j) => (
              <span
                key={j}
                className="block h-7 w-7 rounded-full transition-[background-color,box-shadow] duration-150 sm:h-10 sm:w-10"
                style={{
                  backgroundColor: lit >= i ? "#E32636" : "#1F1F26",
                  boxShadow: lit >= i ? "0 0 28px rgba(227,38,54,0.75)" : "none",
                }}
              />
            ))}
          </div>
        ))}
      </div>
      <p className="label-mono mt-10 text-white">
        {out ? <span className="text-volt">{t.intro.out}</span> : t.intro.idle}
      </p>
    </motion.div>
  );
};
